import { render, staticRenderFns } from "./EditarPedido.vue?vue&type=template&id=82c0139a"
import script from "./EditarPedido.vue?vue&type=script&lang=js"
export * from "./EditarPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports